import { useState } from 'react';

import { getValuesForSelectedOptions } from 'commons/productUtils';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import usePdpSelectedOptionsVariantSku from 'components/consumer/PDP/state/pdpSelectedOptionsVariantSku/usePdpSelectedOptionsVariantSku';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useProductPrice from '../useProductPrice';
import useProductFavoriteV2 from '../useProductFavoriteV2';

const getEventData = ({
  sku,
  product,
  price,
  optionPrice,
  options,
  selectedOptions,
  isFavorited = false,
  isDecideLater = false,
  imageLocation,
  imageFilename,
  position,
  totalImages,
}) => {
  const { fabric } = getValuesForSelectedOptions(options, selectedOptions);
  return {
    sku,
    fabric_id: fabric?.id || 0,
    fabric_name: isDecideLater ? 'Decide Later' : fabric?.value || '',
    fabric_color: fabric?.color || '',
    image_filename: imageFilename,
    image_location: imageLocation,
    position,
    total_images: totalImages,
    favorited: isFavorited,
    product_id: product?.id,
    product_name: product?.name,
    product_family: product?.family?.name,
    product_type: product?.type?.name,
    price: (price?.final_price ?? 0) + optionPrice,
    full_price: (price?.original_price ?? 0) + optionPrice,
  };
};

const usePDPViewGalleryImageEvent = () => {
  const { isFavorited } = useProductFavoriteV2();
  const { data: priceData } = useProductPrice();
  const { data: optionData } = usePDPOptions();
  const { data: basicDetails } = usePDPBasicDetails();
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const selectedOptionsVariantSku = usePdpSelectedOptionsVariantSku();

  const [lastImage, setLastImage] = useState(null);

  const viewGalleryImageEvent = ({
    imageLocation,
    imageFilename,
    position,
    totalImages,
  }) => {
    const curImg = `${imageLocation}:${position}`;

    if (lastImage === curImg) return;

    setLastImage(curImg);

    getEventData({
      imageLocation,
      imageFilename,
      position,
      totalImages,
      isFavorited,
      product: basicDetails,
      price: priceData?.price,
      optionPrice: priceData?.optionPrice,
      options: optionData.options,
      selectedOptions: optionData.selectedOptions,
      isDecideLater: pdpSelectedCustomizerTab === 'decide-later',
      sku: `${basicDetails?.sku || ''}${selectedOptionsVariantSku || ''}`,
    });
  };

  return {
    viewGalleryImageEvent,
  };
};

export default usePDPViewGalleryImageEvent;
